import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesCrossedFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.273 1 1 2.273l1.667 1.666C1.31 5.381 1 7.845 1 12c0 8.75 1.375 10 11 10 3.692 0 6.17-.184 7.823-.904l1.907 1.907 1.273-1.273zM6 7.273V8.9h1.627zM9.827 11.1H6v1.8h5.627z"
                    fill="currentColor"
                />
                <path
                    d="M23 12c0 2.91-.152 4.991-.71 6.472L12.72 8.9H18V7.1H10.92L6.16 2.343C7.652 2.08 9.561 2 12.001 2c9.624 0 11 1.25 11 10"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
CardLinesCrossedFilledSize24Glyph.displayName = 'CardLinesCrossedFilledSize24Glyph';
